import mailEditor from './directives/editor';
import mailEditorWrapper from './directives/mail-editor-wrapper';
import emailSettingsWithGa from './directives/email-settings-with-ga';
import emailSettingsWithGaWithoutSender from './directives/email-settings-with-ga-without-sender';
import mailEditorBlocks from './directives/blocks';
import dropZone from './directives/dropzone';
import sidebarLanguages from './directives/sidebar-languages';
import sidebarHistory from './directives/history';
import rmLangblocks from './directives/rm-langblocks';
import templates from './directives/templates';
import sidebarBlockOverlay from './directives/sidebar-blockoverlay';
import contentCustomization from './directives/content-customization';
import rmBlockSwitch from "./directives/rm-block-switch";
import templateSettings from './directives/template-settings';
import plainContent from './directives/plain-content';
import EditorEventHandler from './services/editor-event-handler';
import SlugService from './services/slug';
import BlockService from './services/blocks';
import CustomBlockParser from './services/custom-block-parser';
import { infiniteScroll } from './directives/infinite-scroll';

export default angular.module('app.mailEditor', [])
    .directive('mailEditor', () => new mailEditor)
    .directive('mailEditorWrapper', () => new mailEditorWrapper)
    .directive('emailSettingsWithGa', () => new emailSettingsWithGa)
    .directive('emailSettingsWithGaWithoutSender', () => new emailSettingsWithGaWithoutSender)
    .directive('mailEditorBlocks', () => new mailEditorBlocks)
    .directive('dropZone', () => new dropZone)
    .directive('templates', () => new templates)
    .directive('sidebarLanguages', () => new sidebarLanguages)
    .directive('sidebarHistory', () => new sidebarHistory)
    .directive('templateSettings', () => new templateSettings)
    .directive('plainContent', () => new plainContent)
    .directive('rmLangblocks', () => new rmLangblocks)
    .directive('sidebarBlockOverlay', () => new sidebarBlockOverlay)
    .directive('contentCustomization', () => new contentCustomization)
    .directive('rmBlockSwitch', () => new rmBlockSwitch)
    .directive('infiniteScroll', infiniteScroll)
    .service('EditorEventHandler', EditorEventHandler)
    .service('SlugService', SlugService)
    .service('BlockService', BlockService)
    .service('CustomBlockParser', CustomBlockParser)
    .name;